/*
 *
 * PartnerWithUs constants
 *
 */

export const DEFAULT_ACTION = '/PartnerWithUs/DEFAULT_ACTION';
export const PAYLOAD_SOURCE_KEY = 'partner_with_us';
export const MANDATORY_FIELDS = ['name', 'email', 'company_name', 'phone'];



// WEBPACK FOOTER //
// client/containers/PartnerWithUs/constants.js